<template>
  <div class="vote-rank" v-if="rankList.length > 0">
    <img src="./images/header_bg.png" />
    <div class="top-rank">
      <img src="./images/header_top.png" class="top-bg" />
      <div class="header-box">
        <div class="header-pic">
          <img :src="rankList[1].avatar" />
        </div>

        <div class="header-name S8 T5">{{ rankList[1].authorName }}</div>
        <div class="vote-num S6 T5">{{ rankList[1].votes }}</div>
      </div>
      <div class="header-box top-one">
        <div class="header-pic">
          <img :src="rankList[0].avatar" />
        </div>

        <div class="header-name S8 T5">{{ rankList[0].authorName }}</div>
        <div class="vote-num S6 T5">{{ rankList[0].votes }}</div>
      </div>
      <div class="header-box top-three">
        <div class="header-pic">
          <img :src="rankList[2].avatar" />
        </div>

        <div class="header-name S8 T5">{{ rankList[2].authorName }}</div>
        <div class="vote-num S6 T5">{{ rankList[2].votes }}</div>
      </div>
    </div>
    <VoteListRank :rankList="rankList.slice(3)"></VoteListRank>
  </div>
</template>
<script>
import api from '@/api/api'
import VoteListRank from '@/components/VoteListRank/VoteListRank'
import { Log } from '@em/ym'
export default {
  components: { VoteListRank },
  data() {
    return {
      rankList: []
    }
  },

  mounted() {
    Log.pageView({
      targetView: 'yktApp:Activity:VoteRank202201208'
    })

    api.vote
      .getPopularList({
        direction: 2
      })
      .then(res => {
        // console.log(res, 46244364)
        if (res.result.code === 0) {
          this.rankList = res.detail.list
        }
      })
  }
}
</script>
<style lang="scss" scoped>
.vote-rank {
  position: absolute;
  background: #046bcc;
  min-height: 100%;
  width: 100%;
  img {
    display: block;
    width: 100%;
  }
  .top-rank {
    position: relative;
    .top-bg {
      width: 600px;
      margin: 0 auto;
    }
    .header-box {
      position: absolute;
      text-align: center;
      top: 94px;
      left: 109px;
      width: 100px;
      .header-pic {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        overflow: hidden;
        border: 1px solid #c5d2e2;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .header-name {
        line-height: 1;
        padding: 10px 0;
        white-space: nowrap;
      }
      .vote-num {
        line-height: 1;
      }
    }
    .top-one {
      left: 314px;
      top: 48px;
      width: 120px;
      .header-pic {
        width: 120px;
        height: 120px;
        border: 1px solid #fad440;
      }
    }
    .top-three {
      left: 536px;
      .header-pic {
        border: 1px solid #ffac7a;
      }
    }
  }
}
</style>
